__turbopack_context__.v({
  "accordionItem": "Accordion-module-scss-module__BY-XZq__accordionItem",
  "checkbox": "Accordion-module-scss-module__BY-XZq__checkbox",
  "content": "Accordion-module-scss-module__BY-XZq__content",
  "icon": "Accordion-module-scss-module__BY-XZq__icon",
  "label": "Accordion-module-scss-module__BY-XZq__label",
});
